// extracted by mini-css-extract-plugin
export default {"button":"weButton_button__R-lsA","hover":"weButton_hover__be8SC","outline":"weButton_outline__YEJH9"};